import { useCallback, useMemo, useState } from 'react';
import { useSearch } from './dataProvider';
import debounce from 'lodash/debounce';
export var useSearchController = function (props) {
    var queryOptions = props.queryOptions, options = props.options, _a = props.wait, wait = _a === void 0 ? 500 : _a;
    var _b = useState(''), query = _b[0], setQuery = _b[1];
    var _c = useSearch(options, queryOptions), search = _c[0], searchData = _c[1];
    var debouncedSearch = useMemo(function () { return debounce(search, wait); }, [search, wait]);
    var doSearch = useCallback(function (query) {
        setQuery(query);
        debouncedSearch(query);
    }, [setQuery, debouncedSearch]);
    return {
        searchData: searchData,
        query: query,
        doSearch: doSearch,
    };
};
